import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';

import {
  AntDProvider,
  AuthProvider,
  LoaderProvider,
  LogoutProvider,
  StoreProvider,
  UserProfileProvider,
} from '@/providers';
import { router } from '@/router';
import { RoleCheckGuard } from '@/shared/components';
import { ENVS, EUserRole } from '@/shared/consts';

import './index.css';
import { FeatureFlagsProvider } from './providers/FeatureFlagsProvider';

async function enableMockServer() {
  if (ENVS.MODE !== 'mock') {
    return;
  }

  const { worker } = await import('@/mocks/browser');

  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}

void enableMockServer().then(() => {
  createRoot(document.getElementById('root')!).render(
    <LogoutProvider>
      <StoreProvider>
        <FeatureFlagsProvider>
          <AuthProvider>
            <UserProfileProvider>
              <RoleCheckGuard
                permittedRoles={[EUserRole.Admin, EUserRole.Curator]}
                urlToRedirect={ENVS.PUBLIC_URL}
              >
                <AntDProvider>
                  <LoaderProvider>
                    <RouterProvider router={router} />
                  </LoaderProvider>
                </AntDProvider>
              </RoleCheckGuard>
            </UserProfileProvider>
          </AuthProvider>
        </FeatureFlagsProvider>
      </StoreProvider>
    </LogoutProvider>,
  );
});
